<template>
    <div class="nutrition-donut-chart">
        <div class="chart-donut">
            <canvas ref="chart" />
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="legendHtml" />
    </div>
</template>

<script>
    export default {
        props: {
            nutritionData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                legendHtml: '',
            };
        },

        mounted() {
            const colors = [
                '#fb9038',
                '#8e53e8',
                '#fd6767',
                '#dddddd',
            ];
            const context = this.$refs.chart.getContext('2d');

            const donutChart = new Chart(context, {
                type: 'doughnut',
                data: {
                    labels: this.nutritionData.labels,
                    datasets: [{
                        data: this.nutritionData.values,
                        backgroundColor: colors,
                        hoverBackgroundColor: colors,
                        borderWidth: 0,
                    }],
                },
                options: {
                    cutoutPercentage: 50,
                    aspectRatio: 1,
                    tooltips: { enabled: false },
                    legend: { display: false },
                    legendCallback: (chart) => {
                        const html = [];
                        html.push('<ul class="chart-legend">');

                        const dataset = chart.data.datasets[0];
                        for (let i = 0; i < dataset.data.length; i++) {
                            html.push('<li class="chart-legend-item">');
                            html.push('<span class="chart-legend-marker" style="background-color:'
                                + dataset.backgroundColor[i] + '"></span>');
                            html.push('<span class="chart-legend-label">'
                                + chart.data.labels[i] + ' '
                                + utils.formatNumber(dataset.data[i]) + ' %</span>');
                            html.push('</li>');
                        }

                        html.push('</ul>');
                        return html.join('');
                    },
                },
            });
            this.legendHtml = donutChart.generateLegend();
        },
    };
</script>
